module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section contact grid"
  }, [_c('div', {
    staticClass: "contact--wrap"
  }, [_c('div', {
    staticClass: "grid--row"
  }, [_c('div', {
    staticClass: "grid--col contact--col"
  }, [_c('cmp-contact-link-list', {
    attrs: {
      "facet": "dark",
      "entries": _vm.contentLinks[0]
    }
  })], 1), _vm._v(" "), (_vm.hasOpeningHours) ? _c('div', {
    staticClass: "grid--col contact--col"
  }, [_c('h2', {
    staticClass: "u-reset contact--opening-hours-title",
    domProps: {
      "textContent": _vm._s(_vm.content.opening_hours.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact--opening-hours-text",
    domProps: {
      "innerHTML": _vm._s(_vm.content.opening_hours.text)
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.hasOpeningHours && !_vm.isMobile) ? _c('div', {
    staticClass: "grid--col contact--col"
  }, [_c('cmp-contact-link-list', {
    attrs: {
      "facet": "dark",
      "entries": _vm.contentLinks[1]
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid--col contact--col"
  }, _vm._l((_vm.plugins), function(plugin, pluginIdx) {
    return _c(plugin.type, {
      key: pluginIdx,
      tag: "component",
      staticClass: "contact--modular-content",
      attrs: {
        "plugin": plugin
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "grid--col contact--col contact--col__wide"
  }, [_c('cmp-map', {
    staticClass: "contact--maps",
    attrs: {
      "mapId": _vm.content.map.map_id,
      "lat": _vm.content.map.lat,
      "lng": _vm.content.map.lng,
      "name": _vm.content.map.name,
      "formattedAddress": _vm.content.map.formatted_address
    }
  })], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-85b9c724", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85b9c724","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/contact/index.vue
// module id = 568
// module chunks = 7